export default __webpack_public_path__ + "static/media/back.47beff12.svg";